export default __webpack_public_path__ + "static/media/rightJoystickArrow.299c4690.svg";